import MetalClient, { BrowserMetricsPlugin, catalog } from '@atlassiansox/metal-client';
import { addRecordableErrorEventListeners } from '@css-xp/uncaught-error';
import { metalClient, METAL_ENV } from './client';
import { getPage } from './src/page-matcher';
import { captureException } from '@atlassian/temp-sentry';

export let client: MetalClient | undefined;

export const initialize = (metalId = '627999b0-b215-45d7-8441-25acb2ce1d03'): void => {
  addRecordableErrorEventListeners({
    uncaughtError: () => {
      metalClient.metric.submit({
        name: catalog.error.UNCAUGHT,
        page: getPage(),
      });
    },
    unhandledRejection: () => {
      metalClient.metric.submit({
        name: catalog.error.UNHANDLED_PROMISE_REJECTION,
        page: getPage(),
      });
    },
  });

  try {
    const pluginsArray = [];
    if (BrowserMetricsPlugin) {
      pluginsArray.push(
        new BrowserMetricsPlugin({
          rootId: 'root',
          histograms: {
            [catalog.performance.FIRST_PAINT]: '1000',
            [catalog.performance.FIRST_MEANINGFUL_PAINT]: '1200',
            [catalog.performance.TIME_TO_FIRST_BYTE]: '800',
          },
        })
      );
    }

    client = new MetalClient({
      settings: {
        meta: {
          synthetic: false,
        },
        getPage,
      },
      plugins: pluginsArray,
      productInfo: {
        metalId: metalId,
        env: METAL_ENV,
        version: '1.0.0',
      },
    });
  } catch (e) {
    /* eslint-disable no-console */
    console.error(`Failed to Submit metal Metric ${e}`);
    captureException(e as Error);
  }
};
